import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';

import { Card, Box } from '@material-ui/core';

import {
  useLayoutStyles,
  StyledWrapper,
} from 'containers/LoginRecoveryPage/styles';
import {
  getLoginCurrentRecoveryStepNameSelector,
  getIsLoadingSelector,
} from 'store/credentials/selectors';
import {
  submitLoginRecoveryStep,
  setLoginRecoveryStep,
} from 'store/credentials/actions';
import {
  RecoveryPagePropsType,
  RecoveryPageSelectorsType,
} from 'containers/LoginRecoveryPage/types';

import HeaderRecovery from 'components/HeaderRecovery';
import { translate } from 'helpers/intl';
import messages from 'containers/LoginRecoveryPage/InsertInfosPage/messages';
import CurrentLoginRecoveryStep from 'containers/LoginRecoveryPage/CurrentLoginRecoveryStep';

const RecoveryLoginPage = (props: RecoveryPagePropsType) => {
  const classes = useLayoutStyles();
  const {
    loginRecoveryStep,
    submitLoginRecoveryStep,
    setLoginRecoveryStep,
    isLoading,
  } = props;
  return (
    <StyledWrapper>
      <Box className={classes.box} paddingY={2}>
        <Card className={classes.paper}>
          <HeaderRecovery title={translate({ ...messages.title }, props)} />
          <CurrentLoginRecoveryStep
            stepName={loginRecoveryStep}
            onSubmitStep={submitLoginRecoveryStep}
            isLoading={isLoading}
            setLoginRecoveryStep={setLoginRecoveryStep}
          />
        </Card>
      </Box>
    </StyledWrapper>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  RecoveryPageSelectorsType
>({
  loginRecoveryStep: getLoginCurrentRecoveryStepNameSelector,
  isLoading: getIsLoadingSelector,
});

const mapDispatchToProps = {
  submitLoginRecoveryStep,
  setLoginRecoveryStep,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RecoveryLoginPage),
);
